/** Backup bundle (manifest) shape — plan §127. One self-describing JSON file. */

export const BACKUP_FORMAT = 'mtp-backup'
export const FORMAT_VERSION = 1
export const SCHEMA_VERSION = 1
export const KDF_ITERATIONS = 210_000
/** Bounded plaintext chunk size so no single decrypt dominates CPU/memory. */
export const CHUNK_BYTES = 512 * 1024

/** Ledger tables included in a backup (sync runtime state is excluded/regenerable). */
export const BACKUP_TABLES = [
  'categories',
  'devices',
  'device_imeis',
  'purchases',
  'sales',
  'payments',
  'expenses',
  'contacts',
  'media',
] as const

export type BackupTable = (typeof BACKUP_TABLES)[number]
export type BackupRecords = Record<BackupTable, unknown[]>

export interface BackupChunk {
  index: number
  nonce: string // base64, unique per chunk
  ciphertext: string // base64
  plaintext_sha256: string // hex sha256 of this chunk's plaintext bytes
  plaintext_bytes: number
}

export interface BackupBundle {
  format: typeof BACKUP_FORMAT
  format_version: number
  schema_version: number
  workspace_id: string
  created_at: string // snapshot time (UTC ISO)
  watermark: string | null // max updated_at across all records
  kdf: { algo: 'PBKDF2'; hash: 'SHA-256'; iterations: number; salt: string }
  cipher: { algo: 'AES-GCM'; length: 256; tag_length: 128 }
  counts: Record<BackupTable, number>
  records_sha256: string // hex sha256 of the full concatenated plaintext
  plaintext_bytes: number
  chunks: BackupChunk[]
}
